/** iter477 58 — règles de validation des numéros par pays. Algérie (+213) : mobile = 9 chiffres commençant par 5/6/7 ; fixe = 8 chiffres commençant par 2/3/4.
 * Autres pays : aucune bibliothèque de validation dans le projet → pas de contrôle (dit dans le rapport). */
export const DZ_RULES = { mobile: { len: 9, first: "567", label: "9 chiffres attendus après +213 (05, 06 ou 07)" }, fixe: { len: 8, first: "234", label: "8 chiffres attendus après +213 (02, 03 ou 04)" } };

/** Chiffres nationaux : retire +213 / 00213, espaces, points, tirets ; le 0 initial est retiré automatiquement (saisie) — contrôle sans lui. */
export const normalizeDz = (raw) => {
  let v = String(raw || "").replace(/[\s.\-()]/g, "");
  if (v.startsWith("+213")) v = v.slice(4);
  else if (v.startsWith("00213")) v = v.slice(5);
  if (/^0\d/.test(v)) v = v.slice(1);
  return v;
};

/** → null si valide (ou pays sans règle), sinon le message d'erreur. */
export const phoneError = (numero, type = "mobile", country = "Algérie") => {
  const v = normalizeDz(numero);
  if (!v) return null;
  if ((country || "Algérie").trim().toLowerCase() !== "algérie") return null;
  const rule = DZ_RULES[type === "fixe" || type === "bureau" || type === "domicile" ? "fixe" : "mobile"];
  if (!/^\d+$/.test(v) || v.length !== rule.len || !rule.first.includes(v[0])) return `Numéro invalide : ${rule.label}`;
  return null;
};

export const phoneValid = (p, country) => !!(p?.numero || "").trim() && !phoneError(p.numero, p.type, country);
